module.exports = __webpack_public_path__ + "img/vascoMiguel.b4235b1f.webp";